import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-magic-uses-water',
  templateUrl: './magic-uses-water.component.html',
  styleUrls: ['./magic-uses-water.component.css']
})
export class MagicUsesWaterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
